<template>
  <div v-if="loaded && current_steps.length > 0">
    <div class="card my-4">
      <div class="card-body d-flex justify-content-center">
        <div class="d-flex align-items-center mx-2 switcher">
          <template v-for="(step, index) in current_steps">
            <template>
              <div class="position-relative">
                <button
                  class="btn"
                  :class="step_marker_classes(index)"
                  @click="current_step = index"
                  :disabled="step_disabled(index)"
                >
                  <span v-if="label_as_step_marker">{{ step.label | titlecase }}</span
                  ><span v-else>{{ index + 1 }}</span>
                </button>
              </div>
              <div
                class="line"
                v-if="current_steps.length > index + 1"
                :class="{ 'bg-primary': current_step > index }"
              ></div>
            </template>
          </template>
        </div>
      </div>
      <div class="card-body pt-0 d-flex">
        <button class="btn btn-outline-primary mr-auto" v-if="current_step > 0" @click="current_step--">
          <i class="fa fa-arrow-left mr-2"></i><span>{{ 'previous' | t }}</span>
        </button>
        <button
          class="btn btn-outline-primary ml-auto"
          v-if="current_steps.length > current_step + 1"
          @click="current_step++"
          :disabled="step_disabled(current_step + 1)"
        >
          <span>{{ 'next' | t }}</span
          ><i class="fa fa-arrow-right ml-2"></i>
        </button>
        <button
          class="btn btn-primary ml-auto"
          v-if="current_steps.length === current_step + 1"
          @click="submit($event)"
          :disabled="step_disabled(current_step + 1)"
        >
          <span>{{ submit_text }}</span>
        </button>
      </div>
    </div>
    <div class="d-flex componenter-wrapper">
      <component
        class="componenter"
        :style="{ transform: 'translate(-' + current_step * 100 + '%)' }"
        :class="{ hidden: index !== current_step }"
        v-for="(step, index) in current_steps"
        v-on:conditions_met="set_conditions_met($event, true)"
        v-on:conditions_not_met="set_conditions_met($event, false)"
        v-bind="$attrs"
        v-bind:is="step_component(step)"
        :key="step_component(step)"
        :ref="step_component(step)"
        v-model="value"
      ></component>
    </div>
  </div>
</template>
<script>
import Alerts, { handle } from '@/utils/alerts';

export default {
  props: {
    value: {
      type: Object
    },
    label_as_step_marker: {
      type: Boolean,
      required: false,
      default: true
    },
    submit_text: {
      type: String,
      required: true
    },
    step_filter: {
      // TODO: Implement step filter to filter steps based on state of model
      type: Function,
      required: false
    },
    step_prefix: {
      type: String,
      required: false
    },
    steps: {
      type: Array,
      required: true
    },
    allow_deep_link: {
      type: Boolean,
      required: false,
      default: false
    },
    intial_step: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      current_step: this.initial_step,
      loaded: false,
      current_steps: []
    };
  },
  methods: {
    submit(event) {
      this.$emit('submit', event);
    },
    /**
     * @param {number} index
     * @return {string[]}
     */
    step_marker_classes(index) {
      return [
        `btn-${index === this.current_step ? '' : 'outline-'}primary`,
        `btn-round${this.label_as_step_marker ? 'ed' : ''}`
      ];
    },
    /**
     * Allow us to deep link to steps using a URL #-param. (e.g. #design)
     * Either with name of step (e.g. 'design') or alternativly with index/number (zero-index)
     * Using name is optimal
     */
    deep_link_step() {
      if (!this.allow_deep_link || !this.$route.hash) {
        return;
      }

      const param = this.$route.hash.replace('#', '');
      if (!isNaN(parseFloat(param)) && isFinite(param)) {
        this.current_step = parseInt(param);
        return;
      }

      const matched_step_index = this.current_steps.findIndex((x) => x.component === param.toLowerCase());
      if (matched_step_index !== -1) {
        this.current_step = matched_step_index;
      }
    },
    step_component(step) {
      return this.step_prefix ? this.step_prefix + step.component : step.component;
    },
    step_disabled(step_index) {
      if (step_index == 0) {
        return false;
      }
      return !this.current_steps[step_index - 1].step_conditions_met;
    },
    set_conditions_met: async function (name, conditions_met) {
      if (name) {
        this.$set(
          this.current_steps.find((s) => s.component == name),
          'step_conditions_met',
          conditions_met
        );
      }
    }
  },
  computed: {},
  mounted() {
    this.current_steps = this.steps;
    this.deep_link_step();
    this.loaded = true;
  }
};
</script>

<style scoped>
.btn-round {
  width: 1.75em;
  height: 1.75em;
  padding: 0 !important;
  font-size: 1.5rem;
  border-radius: 50%;
}

.btn-rounded {
  border-radius: 900px;
}

.hidden {
  opacity: 0;
}

.floater {
  right: 20px;
  bottom: 100px;
  z-index: 2;
  transition: opacity 1000ms;
}

.switcher {
  justify-content: center;
  width: 95%;
}

.line {
  flex: 0 1 100px;
  height: 2px;
  background-color: lightgray;
}

.componenter {
  flex: 1 0 100%;
  /* justify-content: center; */
  transition: opacity 500ms, transform 500ms;
}
.componenter-wrapper {
  overflow: hidden;
  /* align-items: flex-start; */
}
</style>
